/* eslint-disable no-unused-vars */
import { postRemediationUsersWithoutManager, postRemediationUsersWithDuplicateEmployeeId, postRemediationUsersWithoutCustomAttribute, postRemediationUsersWithManagerDisabled, postRemediationUsersNotInConstellationToutLeMonde, postRemediationUsersNotInTeamToutLeMonde, postRemediationUsersWithoutLicenseIntune, postRemediationUsersBALWithManager, postRemediationUsersBALWithoutSponsors, postRemediationUsersBALOwnerOfGroup, postRemediationUsersBALWithLicense, postRemediationUsersBALWithGroup, postRemediationUsersManagerWithoutGrpSecManager, postRemediationUsersManagerWithoutCustomAttribute5, postRemediationUsersExternalWithoutDesactivationDate, postRemediationUsersWithoutLicenseDefender } from '../api/internal/usersInternalApi.js';

export const remediationConfig = {
    usersWithoutManager: {
        key: 'usersWithoutManager',
        title: 'Users without Manager',
        description: 'Cette remédiation envoie un email aux RH pour demander l\'attribution d\'un manager pour les utilisateurs qui n\'en ont pas.',
        remediationFunction: postRemediationUsersWithoutManager,
        formatResultMessage: (element, status) => ({
            sentTo: element.sentTo,
            message: element.message,
            verified: element.verified,
            result: element.result
        }),
        buttonLabel: 'Send mail to RH'
    },
    
    usersWithDuplicateEmployeeId: {
        key: 'usersWithDuplicateEmployeeId',
        title: 'Users with Duplicate Employee ID',
        description: 'Cette remédiation génère automatiquement un nouvel employeeId unique pour chaque utilisateur ayant un employeeId en doublon dans son département.',
        remediationFunction: postRemediationUsersWithDuplicateEmployeeId,
        formatResultMessage: (element, status) => ({
            verified: element.verified,
            result: element.result,
            warnings: element.verificationWarnings
        }),
        buttonLabel: 'Generate unique Employee IDs'
    },
    
    usersMissingCustomAttributes: {
        key: 'usersMissingCustomAttributes',
        title: 'Users without Custom Attribute',
        description: 'Cette remédiation envoie un email aux RH pour demander de renseigner les attributs personnalisés manquants (date d\'entrée, agence, étoile contractuelle).',
        remediationFunction: postRemediationUsersWithoutCustomAttribute,
        formatResultMessage: (element, status) => ({
            sentTo: element.sentTo,
            missingAttributes: element.missingAttributes,
            verified: element.verified,
            result: element.result
        }),
        buttonLabel: 'Send mail to RH'
    },

    usersWithManagerDisabled: {
        key: 'usersWithManagerDisabled',
        title: 'Users manager disabled',
        description: 'Cette remédiation envoie un email aux RH pour demander l\'attribution d\'un nouveau manager pour les utilisateurs qui ont un manager désactivé.',
        remediationFunction: postRemediationUsersWithManagerDisabled,
        formatResultMessage: (element, status) => ({
            sentTo: element.sentTo,
            message: element.message,
            verified: element.verified,
            result: element.result
        }),
        buttonLabel: 'Send mail to RH'
    },

    usersNotInConstellationToutLeMonde: {
        key: 'usersNotInConstellationToutLeMonde',
        title: 'Users not in Constellation Tout le Monde',
        description: 'Cette remédiation ajoute les utilisateurs qui ne sont pas dans le groupe "Constellation Tout le Monde".',
        remediationFunction: postRemediationUsersNotInConstellationToutLeMonde,
        formatResultMessage: (element, status) => ({
            warnings: element.verificationWarnings,
            message: element.message,
            verified: element.verified,
            result: element.result
        }),
        buttonLabel: 'Start remediation'
    },

    usersNotInTeamToutLeMonde: {
        key: 'usersNotInTeamToutLeMonde',
        title: 'Users not in Team Tout le Monde',
        description: 'Cette remédiation ajoute les utilisateurs qui ne sont pas dans le groupe "Team Tout le Monde".',
        remediationFunction: postRemediationUsersNotInTeamToutLeMonde,
        formatResultMessage: (element, status) => ({
            warnings: element.verificationWarnings,
            message: element.message,
            verified: element.verified,
            result: element.result
        }),
        buttonLabel: 'Start remediation'
    },

    usersWithoutLicenseIntune: {
        key: 'usersWithoutLicenseIntune',
        title: 'Users without license Intune',
        description: "Cette remédiation ajoute les utilisateurs qui n'ont pas de licence Intune dans le groupe 'GRP_LIC_O365_INTUNE_CSP'.",
        remediationFunction: postRemediationUsersWithoutLicenseDefender,
        formatResultMessage: (element, status) => ({
            warnings: element.verificationWarnings,
            message: element.message,
            verified: element.verified,
            result: element.result
        }),
        buttonLabel: 'Start remediation'
    },

    usersWithoutLicenseDefender: {
        key: 'usersWithoutLicenseDefender',
        title: 'Users without license Defender',
        description: "Cette remédiation ajoute les utilisateurs qui n'ont pas de licence Defender dans le groupe 'GRP_LIC_DEFENDER_FOR_ENDPOINT_P2_MPN_ET_CSP'.",
        remediationFunction: postRemediationUsersWithoutLicenseDefender,
        formatResultMessage: (element, status) => ({
            warnings: element.verificationWarnings,
            message: element.message,
            verified: element.verified,
            result: element.result
        }),
        buttonLabel: 'Start remediation'
    },

    usersBALWithManager: {
        key: 'usersBALWithManager',
        title: 'Users BAL with Manager',
        description: "Cette remédiation supprime le manager des boîtes aux lettres partagées qui en ont un attribué.",
        remediationFunction: postRemediationUsersBALWithManager,
        formatResultMessage: (element, status) => ({
            verified: element.verified,
            result: element.result,
            warnings: element.verificationWarnings
        }),
        buttonLabel: 'Start remediation'
    },

    usersBALWithoutSponsors: {
        key: 'usersBALWithoutSponsors',
        title: 'Users BAL without Sponsors',
        description: "Cette remédiation envoie un email aux RSSI pour demander l'attribution d'un sponsor aux boîtes aux lettres partagées qui en ont besoin.",
        remediationFunction: postRemediationUsersBALWithoutSponsors,
        formatResultMessage: (element, status) => ({
            verified: element.verified,
            result: element.result,
            warnings: element.verificationWarnings,
            message: element.message,
            sentTo: element.sentTo,
        }),
        buttonLabel: 'Send mail to RSSI'
    },

    usersBALOwnerOfGroup: {
        key: 'usersBALOwnerOfGroup',
        title: 'Users BAL owner of group',
        description: "Cette remédiation retirer l'utilisateur du groupe en tant que propriétaire si un autre membre est propriétaire dessus sinon envoie un email aux RSSI pour les informer que des boîtes aux lettres partagées sont propriétaires de groupes Microsoft 365, ce qui n'est pas recommandé.",
        remediationFunction: postRemediationUsersBALOwnerOfGroup,
        formatResultMessage: (element, status) => ({
            verified: element.verified,
            message: element.message,
            result: element.details?.groupsRemoved.map((row) => `nom : ${row.name}, type : ${row.type}`) || [],
            groupsFailed: element.details?.groupsFailed || [],
            warnings: element.warnings,
            details: element.details?.sentTo 
                ? [`📧 Email envoyé à: ${element.details.sentTo}`] 
                : []
        }),
        buttonLabel: 'Start remediation'
    },

    usersBALWithLicense: {
        key: 'usersBALWithLicense',
        title: 'Users BAL with License',
        description: "Cette remédiation retire les licences aux boîtes aux lettres partagées qui en ont.",
        remediationFunction: postRemediationUsersBALWithLicense,
        formatResultMessage: (element, status) => ({
            verified: element.verified,
            result: element.result,
            warnings: element.verificationWarnings,
            message: element.message,
        }),
        buttonLabel: 'Start remediation'
    },

    usersBALWithGroup: {
        key: 'usersBALWithGroup',
        title: 'Users BAL with Group',
        description: "Cette remédiation supprime les boîtes aux lettres partagées des groupes qu'ils ont toujours d'affectés.",
        remediationFunction: postRemediationUsersBALWithGroup,
        formatResultMessage: (element, status) => {
            // Groupes supprimés avec succès
            const removedSuccess = element.details?.groupsRemoved
                ?.filter((row) => row.verified === true)
                .map((row) => `✅ ${row.name} (${row.type})`) || [];
            
            // Groupes supprimés mais non vérifiés (warnings)
            const removedWarnings = element.details?.groupsRemoved
                ?.filter((row) => row.verified === false)
                .map((row) => `⚠️ ${row.name} (${row.type}) - Non vérifié`) || [];
            
            // Groupes en échec
            const failed = element.details?.groupsFailed
                ?.map((row) => `❌ ${row.name} (${row.type}) - ${row.error}`) || [];
            
            return {
                verified: element.verified,
                message: element.message,
                result: [...removedSuccess, ...removedWarnings, ...failed],
                warnings: element.verificationWarnings || []
            };
        },
        buttonLabel: 'Start remediation'
    },

    usersManagerWithoutGrpSecManager: {
        key: 'usersManagerWithoutGrpSecManager',
        title: 'Users manager without GRP_SEC_MANAGER',
        description: "Cette remédiation ajoute les utilisateurs qui sont manager dans le groupe GRP_SEC_MANAGERS.",
        remediationFunction: postRemediationUsersManagerWithoutGrpSecManager,
        formatResultMessage: (element, status) => ({
            verified: element.verified,
            result: element.result,
            warnings: element.verificationWarnings,
            message: element.message,
        }),
        buttonLabel: 'Start remediation'
    },
    
    usersManagerWithoutCustomAttribute5: {
        key: 'usersManagerWithoutCustomAttribute5',
        title: 'Users manager without Custom Attribute 5',
        description: "Cette remédiation ajoute le Custom Attribute 5 'Manager' sur les utilisateurs qui sont manager dans Exchange Online.",
        remediationFunction: postRemediationUsersManagerWithoutCustomAttribute5,
        formatResultMessage: (element, status) => ({
            verified: element.verified,
            result: Array.isArray(element.result) ? element.result : [element.result],
            warnings: element.verificationWarnings || [],
            message: element.message || '',
        }),
        buttonLabel: 'Start remediation'
    },

    usersExternalWithoutDesactivationDate: {
        key: 'usersExternalWithoutDesactivationDate',
        title: 'Users external without desactivation date',
        description: 'Cette remédiation ajoute une date de désactivation des utilisateurs externes.',
        remediationFunction: postRemediationUsersExternalWithoutDesactivationDate,
        formatResultMessage: (element, status) => ({
            verified: element.verified,
            result: element.result,
            warnings: element.verificationWarnings
        }),
        buttonLabel: 'Generate desactivation dates'
    },
}